<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div class="text-sm border-b border-n-weak">
    <button
      class="flex items-center justify-between w-full gap-2 px-4 py-3 m-0 text-left transition-colors select-none cursor-grab hover:bg-n-alpha-1 drag-handle"
      @click.stop="onToggle"
    >
      <div class="flex items-center min-w-0 gap-2">
        <EmojiOrIcon class="inline-block w-5" :icon="icon" :emoji="emoji" />
        <h5
          class="m-0 text-[11px] font-medium tracking-wider uppercase truncate text-n-slate-10"
        >
          {{ title }}
        </h5>
      </div>
      <div class="flex flex-row items-center gap-1 flex-shrink-0">
        <slot name="button" />
        <span
          class="transition-transform i-lucide-chevron-down size-4 text-n-slate-10"
          :class="{ '-rotate-90 rtl:rotate-90': !isOpen }"
        />
      </div>
    </button>
    <div v-if="isOpen" :class="compact ? 'p-0 pb-2' : 'px-4 pb-4'">
      <slot />
    </div>
  </div>
</template>
